jQuery(function () {
    jQuery('.bt_top').on('click', function (event) {
        jQuery('body, html').stop().animate({ scrollTop: 0 }, 800);
        event.preventDefault();
    });



    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth > 640) {
    } else {
        jQuery('.logo-res__rs').insertAfter('div.menu-bottom>div:first-child');
        jQuery('footer .menu-bottom>li>ul').hide();
        jQuery('footer .menu-bottom>li>a').click(function () {
            event.preventDefault();
            jQuery(this).next('ul').toggle();
            jQuery(this).parent().toggleClass('active');


        });
    }


    if ($("body").hasClass("nos-valeurs") || $("body").hasClass("index") ) {


        jQuery.getScript('https://cdn.amcharts.com/lib/4/core.js').done(function() {
            jQuery.getScript('https://cdn.amcharts.com/lib/4/charts.js').done(function() {
                jQuery.getScript('https://cdn.amcharts.com/lib/4/themes/animated.js').done(function() {

                am4core.ready(function() {
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end
                    // Create chart instance
                    var chart = am4core.create("chartdiv", am4charts.PieChart);
                    // Add data
                    chart.data = [
                        { "sector": "Bienveillance", "size": 25 , "tooltip":"C'est toute l’attention que l’on va porter aux autres"},
                        { "sector": "Réactivité", "size": 25, "tooltip":"Prendre en charge rapidement les situations, les prioriser et les mener à bien"},
                        { "sector": "Culture de la qualité", "size": 25 ,"tooltip":"Analyser ses pratiques avec un regard neutre pour s’améliorer en permanence"},
                        { "sector": "Engagement", "size": 25, "tooltip":"Le sentiment d’attachement pour son entreprise et une participation à son développement"}
                    ];
        
                    
                    // Add label
                    chart.innerRadius = 80;
                    var label = chart.seriesContainer.createChild(am4core.Label);
                    label.text = "";
                    label.horizontalCenter = "middle";
                    label.verticalCenter = "middle";
                    label.fontSize = 50;
                    // Add and configure Series
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "size";
                    pieSeries.dataFields.category = "sector";
                    pieSeries.slices.template.tooltipText  = "{literal}{tooltip}{/literal}";
            
                    // couleur du texte des tooltips sur le graph => 
                    pieSeries.tooltip.autoTextColor = false;
                    pieSeries.tooltip.label.fill = am4core.color("#ffffff");
            
                    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                    if (viewportWidth > 640) {
                       
                    } else {
                        pieSeries.alignLabels = false;
                        pieSeries.labels.template.radius = am4core.percent(-2);
                        pieSeries.labels.template.fill = am4core.color("black");
                        
                    }
                    chart.responsive.enabled = true;
                    // Animate chart data
                    pieSeries.colors.list = [
                        am4core.color("#ee7309"), //orange
                        am4core.color("#949698"), // gris
                        am4core.color("#ec008c"), // rose
                        am4core.color("#024B9A"), //bleu
                    ];
            

                    const myTimeout = setTimeout(loaded, 50);
            
            
                }); // end am4core.ready()

                })
            });
        });



        


  

       
   
       
      
      }





});




jQuery(window).on('resize', function () {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 640) {
        jQuery('.logo-res__rs').insertAfter('div.menu-bottom>div:first-child');
        jQuery('footer .menu-bottom>li>ul').hide();
        jQuery('footer .menu-bottom>li>a').click(function () {
            event.preventDefault();
            jQuery(this).next('ul').toggle();
            jQuery(this).parent().toggleClass('active');

        });
    } else {
        jQuery('.logo-res__rs').insertAfter('.logo-res__logo');
        jQuery('footer .menu-bottom>li>ul').show();
    }

});


var map;
function zoomMap(lat, lng, id) {
    jQuery.scrollTo(jQuery("#map"), { duration: 500, offset: -100 });
    map.setView([lat, lng], 19);
    map.eachLayer(function(layer) {
        if (layer.itemId && layer.itemId == id) {
            layer.openPopup();
        }
    })
}
function highlightItem(id) {
    var cli = '#clinic' + id;
    jQuery('.list-clinics__scroll').scrollTo(cli, 1000, 'swing');
    jQuery('.list-clinics__item').removeClass('focused')
    jQuery(cli).addClass('focused');
}

function launchMap(container, markers) {
    map = L.map(container, {
        minZoom: 5,
        maxZoom: 18
    }).setView([46.71109, 1.7191036], 6);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {attribution: ''}).addTo(map);
    var markerscluster = L.markerClusterGroup({
        //disableClusteringAtZoom: 15
    });
    //Loop through the markers 
    for (var i = 0; i < markers.length; i++) {
     
        var markerLocation = new L.LatLng(markers[i].lat, markers[i].lng);
        var marker = new L.Marker(markerLocation);

        marker.bindPopup('<b class="text-center">'+markers[i].titre+'</b>');

        
        marker.itemId = markers[i].id;
        marker.on('click', function(marker) {
            highlightItem(this.itemId)
        })
        markerscluster.addLayer(marker);
    }
    map.addLayer(markerscluster);
    map.on("moveend", function (e) {
        var displayed = markers.filter(function(marker) {
            var loc = new L.LatLng(marker.lat, marker.lng);
            return map.getBounds().contains(loc);
        });
        jQuery('.list-clinics__item').hide();
        jQuery('.list-clinics__item').removeClass('focused')
        if (displayed.length > 0) {
            jQuery(displayed.map(function(marker) {
                return '#clinic' + marker.id;
            }).join(',')).show();
            jQuery('.js-offres-total').html('<b>'+displayed.length + '</b> resultat' + (displayed.length > 1 ? 's' : ''));
        } else {
            jQuery('.js-offres-total').text('Pas de résultats');
        }
    });
}


function setupMap(map, markers) {
    [
        'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css',
        'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.css',
        'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css'
    ].forEach(function(css) {
        jQuery('<link>').appendTo('head').attr({
            type: 'text/css', 
            rel: 'stylesheet',
            href: css,
            crossorigin: ''
        });
    });
    jQuery.getScript('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js').done(function() {
        jQuery.getScript('https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js').done(function() {
            launchMap(map, markers);
        });
    });
}

function loaded(){
    jQuery('#chartdiv tspan').text(function(i, t) {
        // return t.replace(': 25.0%', ''); => easy way
        return t.replace(/:\s\d+(\.\d+)?%$/, ''); // more secure way
    })
}




